export const AnimateBlock1 = () => {
    const pathData = "M93.23 8.998C86.916-6.36-40-10 14 107.498";

    return (
        <svg className="path path--2" xmlns="http://www.w3.org/2000/svg" width="94" height="108" viewBox="0 0 94 108" fill="none">
            <path id="motionPath2"
                d={pathData}
                stroke="#fff"
                strokeDasharray="2 2"
                fill="none" />

            <defs>
                <g id="icon" transform="rotate(180 14 6)">
                    <g filter="url(#a)">
                        <rect width="17" height="11" x="4.5" y=".5" stroke="#027BC4" rx="2.5" shapeRendering="crispEdges" />
                    </g>
                    <path stroke="#fff" d="m5.75 2 6.596 5.48a1 1 0 0 0 1.263.013L20.5 2" />
                    <path stroke="#027BC4" strokeWidth=".8" d="m5.125 3 7.182 6.417a1 1 0 0 0 1.317.013L21.125 3" />
                    <path stroke="#0278BF" d="m6 11 4-4M20 11l-4-4" />
                    <g filter="url(#b)">
                        <rect width="15.5" height="9.5" x="5.25" y="1.25" stroke="#fff" strokeWidth=".5" rx="1.75"
                            shapeRendering="crispEdges" />
                    </g>
                    <defs>
                        <filter id="a" width="26" height="20" x="0" y="0" colorInterpolationFilters="sRGB"
                            filterUnits="userSpaceOnUse">
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                            <feOffset dy="4" />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9794_168" />
                            <feBlend in="SourceGraphic" in2="effect1_dropShadow_9794_168" result="shape" />
                        </filter>
                        <filter id="b" width="24" height="18" x="1" y="1" colorInterpolationFilters="sRGB"
                            filterUnits="userSpaceOnUse">
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                            <feOffset dy="4" />
                            <feGaussianBlur stdDeviation="2" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9794_168" />
                            <feBlend in="SourceGraphic" in2="effect1_dropShadow_9794_168" result="shape" />
                        </filter>
                    </defs>
                </g>
            </defs>

            <g transform="translate(-5 -5)">
                {Array.from({ length: 10 }).map((_, index) => (
                    <use key={index} href="#icon">
                        <animateMotion
                            dur="7s"
                            repeatCount="indefinite"
                            rotate="auto"
                            path={pathData}
                            calcMode="linear"
                            begin={`-${index}s`}
                        />
                    </use>
                ))}
            </g>
        </svg>
    )
}

export const AnimateBlock2 = () => {
    const pathData = "M0.499854 6.99796C133.5 -35.0024 214 146.999 83.9998 186.999";

    return (
        <svg className="path path--3"
            xmlns="http://www.w3.org/2000/svg"
            width="166"
            height="190"
            viewBox="0 0 166 190"
            fill="none"
        >
            <path
                id="motionPath3"
                d={pathData}
                stroke="#fff"
                strokeDasharray="2 2"
                fill="none"
            />

            <defs>
                <g id="icon2">
                    <g filter="url(#a)">
                        <rect width="17" height="11" x="4.5" y=".5" stroke="#027BC4" rx="2.5" shapeRendering="crispEdges" />
                    </g>
                    <path stroke="#fff" d="m5.75 2 6.596 5.48a1 1 0 0 0 1.263.013L20.5 2" />
                    <path stroke="#027BC4" strokeWidth=".8" d="m5.125 3 7.182 6.417a1 1 0 0 0 1.317.013L21.125 3" />
                    <path stroke="#0278BF" d="m6 11 4-4M20 11l-4-4" />
                    <g filter="url(#b)">
                        <rect width="15.5" height="9.5" x="5.25" y="1.25" stroke="#fff" strokeWidth=".5" rx="1.75"
                            shapeRendering="crispEdges" />
                    </g>
                </g>
                <filter id="a" width="26" height="20" x="0" y="0" colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9794_168" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_9794_168" result="shape" />
                </filter>
                <filter id="b" width="24" height="18" x="1" y="1" colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9794_168" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_9794_168" result="shape" />
                </filter>
            </defs>

            <g>
                {Array.from({ length: 16 }).map((_, index) => (
                    <g key={index} transform="translate(0, -18)">
                        <use href="#icon2" />
                        <animateMotion
                            dur="7s"
                            repeatCount="indefinite"
                            rotate="auto"
                            begin={`-${index}s`}
                        >
                            <mpath href="#motionPath3" />
                        </animateMotion>
                    </g>
                ))}
            </g>
        </svg>
    );
};
